import React from 'react';
import { dispactConnect, Action, combineAction } from 'combine-action';

import * as TYPE from './pieces'

class Kotak extends React.Component {

    constructor(props) {
        super(props);

        const id = this.props.hurup + this.props.number;
        const bidak = ((this.props.number - 1) * 8) + this.props.pos + this.props.number;
        this.state = {
            id,
            bidak,
        };
        this.convert = {
            'a': 1, "b": 2, "c": 3, "d": 4, "e": 5, "f": 6, "g": 7, "h": 8
        };
    }

    renderNode() {
        if (this.props.biji !== '-') {
            const Piece = TYPE[this.props.biji];
            return (
                <Piece />
            );
        } else {
            return null;
        }
    }

    showInfo(id) {
        return this.props.showInfo ? (<div style={{ position: 'absolute', userSelect: 'none' }}>{id}</div>) : null;
    }

    playingMoving() {
        const { id } = this.state;
        const canMove = this.props.legalMove1[id];
        if (canMove) {
            if (this.props.focus === id) {
                this.props.updateState({ focus: '', canMove: [] });
            } else {
                if (canMove) {
                    this.props.updateState({ canMove, focus: id });
                } else {
                    this.props.updateState({ canMove: [] });
                }
            }
        } else if (this.props.canMove.includes(id)) {
            //check if pion promotion 
            if (this.props.allPromot[id]) {
                this.props.updateState({ popupPromosi: true, pionSelectPromotion: id });
            } else {
                var move = this.props.focus + id;
                var logMoves = this.props.logMoves;
                logMoves.push(move);
                this.props.updateState({ logMoves, canMove: [], focus: '' });
                var logJoin = logMoves.join(" ");
                this.movesFen(logJoin);
            }

        }
    }

    movesFen(logJoin) {
        // this.worker.postMessage(`position startpos moves ${logJoin}`);
        console.log(`position fen ${this.props.susunanModif} ${this.props.runaway} - - 0 1 moves ${logJoin}`);
        this.props.postMessage(`position fen ${this.props.susunanModif} ${this.props.runaway} - - 0 1 moves ${logJoin}`);
        this.props.postMessage(`d`);
        this.props.postMessage(`go depth 12`);
    }

    //MODE DESIGN ONLY
    movingPion(bijis, from, to) {
        var group = [];
        Array.from(document.querySelectorAll(".line")).forEach((item, index) => {
            var line = [];
            var num = 0;
            Array.from(item.children).forEach((kotak, idx) => {
                var biji = kotak.attributes.getNamedItem('data-biji').nodeValue;
                var id = kotak.attributes.getNamedItem('data-id').nodeValue;
                if (from === id) {
                    biji = '-';
                }
                if (to === id) {
                    biji = bijis;
                }

                if (biji === '-') {
                    num = num + 1;
                    if (idx === (item.children.length - 1)) {
                        line.push(num);
                    }
                } else {
                    if (num) {
                        line.push(num);
                        line.push(biji);
                        num = 0;
                    } else {
                        line.push(biji);
                    }
                }
            });
            group.push(line);
        });
        var susunan = group.map(item => item.join('')).join('/');
        this.props.updateState({ susunan, susunanModif: susunan, logMoves: [], jalanLawan: [], focus: '' });
        setTimeout(() => {
            this.movesFen([]);
        }, 500)
    }

    modeDesain() {
        const { id } = this.state;
        if (this.props.focus === id) {
            this.props.updateState({ focus: '' });
        } else {
            if (this.props.focus) {
                var biji = document.querySelector(`.${this.props.focus}`).getAttribute('data-biji');
                this.movingPion(biji, this.props.focus, id);
            } else {
                this.props.updateState({ focus: id });
            }
        }
    }

    render() {
        const { id, bidak } = this.state;
        const color = bidak % 2 ? 'white' : 'black';
        const focused = this.props.focus === id ? 'focused' : '';
        const legalmove = this.props.canMove.includes(id) ? 'legalmove' : '';
        const jalanLawan = this.props.jalanLawan.includes(id) ? 'jalanLawan' : ''

        return (
            <div className={`kotak ${id} ${bidak} ${focused} ${legalmove}`}
                data-biji={this.props.biji}
                data-id={id}
                onClick={() => {
                    if (!this.props.modeDesain) {
                        this.playingMoving();
                    } else {
                        this.modeDesain();
                    }
                }}
            >
                <div className={`isi ${color}`} data-biji={this.props.biji}>
                    {this.showInfo(id)}
                    <div className="biji">
                        {jalanLawan ? (<div className="jalanlawan"></div>) : null}
                        {this.renderNode()}
                    </div>
                </div>
            </div>
        );
    }
}

export default dispactConnect((Kotak), combineAction(Action.HomeAction), ['HomeReducer']);
